import * as React from 'react';

import { HomePageView } from './home-page.view';
import { useFeatureHomePage } from './use-feature-home-page';

type HomePageProps = {
  headerComponent?: React.ReactElement | null;
};

export const HomePage = ({ headerComponent }: HomePageProps) => {
  const { featureHomePageLoading, featureHomePage } = useFeatureHomePage();

  return (
    <HomePageView
      isLoading={featureHomePageLoading}
      featureHomePage={featureHomePage}
      headerComponent={headerComponent}
    />
  );
};
